import { z } from 'zod'
import { makeFieldKeys, validateWithZodSchema } from '../../core/utils/utilities.ts'

const TaskDealsModelSchema = z
  .object({
    id: z.string(),
    task_id: z.string(),
    deal_id: z.string()
  })
  .strict()

export const TaskDealsModelFields = makeFieldKeys(TaskDealsModelSchema)

export type TaskDealsModel = z.infer<typeof TaskDealsModelSchema>

function validateTaskDealsModel(data: unknown): TaskDealsModel {
  try {
    return validateWithZodSchema(TaskDealsModelSchema, data, 'task deals model')
  } catch (error) {
    throw new Error(`Task deals model validation failed: ${error}`)
  }
}
